import produce from "immer";

interface State {
  loading: boolean;
  message: string | null;
  policyNumber?: string;
}

export const initialState: State = {
  loading: false,
  message: null,
  policyNumber: undefined,
};

type Action =
  | { type: "FETCH_DATA" }
  | { type: "FETCH_ERROR"; payload: { message: string } }
  | { type: "UPDATE_POLICY_NUMBER"; payload: { policyNumber?: string } };

export const searchDlpPolicyReducer = (state: State, action: Action): State => {
  switch (action.type) {
    case "FETCH_DATA":
      return produce(state, (draft) => {
        draft.loading = true;
        draft.message = null;
      });
    case "FETCH_ERROR":
      return produce(state, (draft) => {
        draft.loading = false;
        draft.message = action.payload.message;
      });
    case "UPDATE_POLICY_NUMBER":
      return produce(state, (draft) => {
        draft.policyNumber = action.payload.policyNumber;
      });
  }
};
